<template>
  <v-dialog v-model="show" max-width="913">
    <v-card>
      <v-card-title class="body-1">
        Payment logs
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table
          v-if="logs.length"
          class="overflow-y-auto"
          style="max-height: 60vh;"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="secondary--text darken">
                  ID
                </th>
                <th class="secondary--text darken">
                  Related ID
                </th>
                <th class="secondary--text darken">
                  Type
                </th>
                <th class="secondary--text darken">
                  Payment method
                </th>
                <th class="secondary--text darken">
                  Operator
                </th>
                <th class="secondary--text darken">
                  Time
                </th>
                <th class="secondary--text darken">
                  Amount in cents
                </th>
                <th class="secondary--text darken">
                  Status
                </th>
                <th class="secondary--text darken">
                  Refunded
                </th>
                <th class="secondary--text darken">
                  Response
                </th>
                <!-- <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.COST') }}
                  </th>
                  <th class="secondary--text darken">
                    {{
                      $vuetify.lang.t('$vuetify.FLEET_REPORT.USED_FLEET_CREDIT')
                    }}
                  </th>
                  <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.FLEET_REPORT.SELF_PAID') }}
                  </th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log.Id">
                <td>{{ log.Id }}</td>
                <td>{{ log.RelatedPaymentLogId }}</td>
                <td>{{ log.Type }}</td>
                <td>{{ log.PaymentMethod }} {{ log.PaymentMethodDetails }}</td>
                <td>{{ log.Operator }}</td>
                <td>{{ dateEE(log.CreatedAt) }}</td>
                <td>{{ log.CostInCents }}</td>
                <td>
                  <span
                    v-if="log.StatusCode == 0"
                    class="success white--text pa-1 rounded"
                  >
                    OK
                  </span>
                  <span
                    v-if="log.StatusCode == -1"
                    class="warning white--text pa-1 rounded"
                  >
                    ?
                  </span>
                  <span
                    v-if="log.StatusCode > 0"
                    class="error white--text pa-1 rounded"
                  >
                    ERROR
                  </span>
                </td>
                <td>
                  <v-icon :color="log.Refunded ? 'success' : 'error'">{{
                    log.Refunded ? 'mdi-check' : 'mdi-close'
                  }}</v-icon>
                </td>
                <td style="width: 400px">{{ log.ResponseData }}</td>
                <!-- <td>{{ sess.TotalCostInCents / 100 }}</td>
                  <td>
                    {{ sess.UsedFleetCreditCents / 100 }}
                  </td>
                  <td>{{ sess.SelfPaidCents / 100 }}</td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-toolbar v-else class="elevation-0">
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loading.state"
            indeterminate
            color="secondary"
          ></v-progress-circular>
          <span v-else>No logs</span>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'PaymentLogsDialog',
  mixins: [formatDate],
  props: {
    sessionId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      logs: []
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.logs = []
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.$store
      .dispatch('sessions/getSessionPaymentLogs', this.sessionId)
      .then(logs => {
        this.logs = logs
      })
  }
}
</script>
